import { render, staticRenderFns } from "./hot_news.vue?vue&type=template&id=365397ef&scoped=true&"
import script from "./hot_news.vue?vue&type=script&lang=js&"
export * from "./hot_news.vue?vue&type=script&lang=js&"
import style0 from "./hot_news.vue?vue&type=style&index=0&id=365397ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365397ef",
  null
  
)

export default component.exports